import { render, staticRenderFns } from "./AbasRelatorios.vue?vue&type=template&id=ca4e6adc&scoped=true&"
import script from "./AbasRelatorios.vue?vue&type=script&lang=js&"
export * from "./AbasRelatorios.vue?vue&type=script&lang=js&"
import style0 from "./AbasRelatorios.vue?vue&type=style&index=0&id=ca4e6adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e6adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
